// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__bHXZp","container":"Skills_container__Bp534"};